'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Controllable = require('../decorators/Controllable');

var _Controllable2 = _interopRequireDefault(_Controllable);

var _UIControlledPopover = require('./UIControlledPopover');

var _UIControlledPopover2 = _interopRequireDefault(_UIControlledPopover);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _Controllable2.default)(_UIControlledPopover2.default, ['open']);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2750/js/tooltip/UIPopover.js
// module id = 194
// module chunks = 171